import React, { memo, useEffect, useState } from 'react';
import Parser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../../../redux/actions';
import './_footer.scss';

const Footer = ({ getSettingsData, ...props }) => {
  const [contactInfo, setContactInfo] = useState(null);
  const [socials, setSocials] = useState(null);

  useEffect(() => {
    getSettingsData().then((res) => {
      const { contact_info, social_media } = res.res;
      setContactInfo(contact_info);
      setSocials(social_media);
    });
  }, [getSettingsData]);

  return (
    <footer id='footer'>
      <div className='container-fluid footerBody'>
        <div className='row justify-content-md-between'>
          <div className='col-lg-9'>
            {contactInfo &&
              contactInfo !== null &&
              contactInfo?.length &&
              (() => <>{Parser(contactInfo)}</>)()}

            {socials && socials !== null && socials?.length && (
              <div className='social-section-footer'>
                <span>Find us on</span>
                <div className='d-flex'>
                  {socials.map((social, i) => (
                    <a
                      key={`${social?.type.toLowerCase()}-${i}`}
                      href={social?.url}
                      rel='noopener noreferrer'
                      target='_blank'
                      className={`${social?.type.toLowerCase()}-icon footerIcon`}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* <h4>CONTACT INFO</h4>
               <a
                className='footer-link mb-3'
                rel='noopener noreferrer'
                target='_blank'
                href='tel:+35627877705'
              >
                +356 27877705
              </a>
               <div className='social-section-footer'>
                <span>Find us on</span>
                <div className='d-flex'>
                  <a
                    href='https://www.facebook.com/inclassicafestival'
                    rel='noopener noreferrer'
                    target='_blank'
                    className='facebook-icon footerIcon'
                  />
                  <a href='#' target='_blank' className='youtube-icon footerIcon'/>
                  <a href='#' target='_blank' className='instagram-icon footerIcon'/>
                </div>
              </div>

              */}

            <div className='privacy-section-footer'>
              <a className='footer-link' href='#'>
                {/* Terms and Conditions */}
              </a>
              <a
                className='footer-link'
                href='/privacy-policy'
                rel='noopener noreferrer'
                target='_blank'
              >
                {/* Privacy */}
              </a>
              <a className='footer-link' href='#'>
                {/* Security */}
              </a>
            </div>
          </div>
          <div className='col-lg-3 d-flex flex-column text-lg-right justify-content-md-between'>
            <div className='footer-icon' />
            <p>
              {' '}
              <Link
                className='footer-link pt-4 d-inline-block text-right'
                rel='noopener noreferrer'
                to='/privacy-policy'
              >
                Privacy policy
              </Link>
              <br />© All rights reserved {new Date().getFullYear()}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

function mapState(state) {
  return {
    settingsData: state.getSettingsData,
  };
}

const actionCreators = {
  getSettingsData: userActions.getSettingsData,
};

export default memo(connect(mapState, actionCreators)(Footer));
